import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

export const addEditWoodChipFormDataFields = [
  {
    name: 'finishWeight',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Finish Weight',
    width: 6,
    required: true,
  },
  {
    name: 'customer',
    typeOfInp: 'input',
    textFieldType: 'text',
    label: 'Customer',
    width: 6,
    required: true,
    disabled: true,
  },
  {
    name: 'sP_Number',
    typeOfInp: 'input',
    textFieldType: 'text',
    label: 'SP Number',
    width: 6,
    required: true,
    disabled: true,
  },
  {
    name: 'mC_Percent',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'MC Percent',
    width: 6,
    required: true,
  },
  {
    name: 'finishDate',
    typeOfInp: 'input',
    textFieldType: 'dateTime-local',
    label: 'Finish Date',
    width: 6,
    required: true,
  },
  {
    name: 'startingWeight',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Starting Weight',
    width: 6,
    required: true,
  },
  {
    name: 'cookTimeHours',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Cook Time (Hours)',
    width: 6,
    required: true,
  },
];

export const InitialAddEditWoodChipFormData = {
  id: null,
  wH_DocketNumber: '',
  finishWeight: '',
  customer: '',
  sP_Number: '',
  mC_Percent: '',
  finishDate: toLocalISO(),
  startingWeight: '',
  cookTimeHours: '',
};
